import React                                    from 'react';
import InputBase                                from '@material-ui/core/InputBase';
import Drawer                                   from '@material-ui/core/Drawer';
import CssBaseline                              from '@material-ui/core/CssBaseline';
import Avatar                                   from '@material-ui/core/Avatar';
import AppBar                                   from '@material-ui/core/AppBar';
import Request                                  from 'superagent';
import TreeView                                 from '@material-ui/lab/TreeView';
import TreeItem                                 from '@material-ui/lab/TreeItem';
import Tooltip                                  from '@material-ui/core/Tooltip';
import Toolbar                                  from '@material-ui/core/Toolbar';
import GridListTileBar                          from '@material-ui/core/GridListTileBar';
import List                                     from '@material-ui/core/List';
import { withStyles }                           from '@material-ui/core/styles';
import { MuiThemeProvider }                     from '@material-ui/core/styles';
import Typography                               from '@material-ui/core/Typography';
import Divider                                  from '@material-ui/core/Divider';
import IconButton                               from '@material-ui/core/IconButton';
import ListItem                                 from '@material-ui/core/ListItem';
import ListItemIcon                             from '@material-ui/core/ListItemIcon';
import ListItemText                             from '@material-ui/core/ListItemText';
import { Button, Paper }                        from '@material-ui/core';
import Iconos                                   from './Icono'
import AuthService                              from '../AuthService';
import {globales,colores,funciones}                     from '../global'
import Switch                                   from '@material-ui/core/Switch';
import FormControlLabel                         from '@material-ui/core/FormControlLabel';
import '../CSS/Style_menu.css';
import Collapse                                 from '@material-ui/core/Collapse';
import { useSpring, animated }                  from 'react-spring'; // web.cjs is required for IE 11 support
import {theme}                                  from '../themeMui';

//////REDIS
import DvrIcon                  from '@material-ui/icons/Dvr';
import ClearAllIcon             from '@material-ui/icons/ClearAll';
import CloseIcon                from '@material-ui/icons/Close';
import CachedIcon               from '@material-ui/icons/Cached';
import DialogTitle              from '@material-ui/core/DialogTitle';
import Dialog                   from '@material-ui/core/Dialog';
import DialogContent            from '@material-ui/core/DialogContent';
import DialogActions            from '@material-ui/core/DialogActions';
import CustomTable              from './CustomTable';
import TableRowsIndexer         from './tableRowsIndexer'
import {Table}                  from '@devexpress/dx-react-grid-material-ui';
import CircularProgress         from '@material-ui/core/CircularProgress';
import Backdrop                 from '@material-ui/core/Backdrop';
import MoodRoundedIcon          from '@material-ui/icons/GrainRounded';

let isVisibleRowSelected = false;
const colorRowSelected =  'rgb('+ colores.tabla.selection +')';
let alternateColorRow1 = colores.tabla.alternateColorRow1;
let alternateColorRow2 = colores.tabla.alternateColorRow2;

const getRowId = row => row.USER;

const columns= [{name: 'USER'   ,title: 'Usuario'}
,{name: 'VALUE'   ,title: 'Solicitudes'}
,{name: 'BLOCKED'   ,title: 'Estado'}
]

const tableColumnExtensions=[
  { columnName: 'USER', align: 'center'}
  ,{ columnName: 'VALUE', align: 'center'}
  ,{ columnName: 'BLOCKED', align: 'center'}
]

var ACTIVAR_REDIS = true

///GUARDA SI ES MOVIL O PC TRUE/FALSE
var movil_pequeño=/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
var movil_ipad=/iPad/i.test(navigator.userAgent);
var lista_encabezado=[]; var lista_filtro=[]; var Lista_general_menu=[];
var ip=globales.ip
var Auth = new AuthService();

  var styles = theme =>({
    root: {
      width: 40,
      height: 24,
      padding: 0,
      margin: theme.spacing(1),
    },
    Switch:{
      padding: 1,
      '&$checked': {
        transform: 'translateX(16px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: '#52d869',
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: '#52d869',
        border: '6px solid #fff',
      },
    },
    thumb: {
      width: 22,
      height: 22,
    },
    track: {
      borderRadius: 26 / 2,
      border: `1px solid grey`,
      backgroundColor: 'grey',
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
    button: {
      margin: movil_pequeño?3:theme.spacing(1),
      paddingRight: theme.spacing(2),
      alignItems: 'center',
      boxShadow: '0px 0px 1px 2px rgba(179,179,179,0.5);-webkit-box-shadow: 0px 1px 1px 1px rgba(179,179,179,0.5);-moz-box-shadow: 0px 0px 2px 1px rgba(179,179,179,1);',
      border: 'none',
      borderRadius:2,
    },
    iconSizeSmall:{
      '& > *:first-child': {fontSize: 17}
    },
  })

  function TransitionComponent(props) {
    const style = useSpring({
      from: { opacity: 0, transform: 'translate3d(70px,0,0)' },
      to: { opacity: props.in ? 1 : 0, transform: `translate3d(${props.in ? 0 : 100}px,1px,0)` },
    });  
    return (
      <animated.div style={style}>
        <Collapse {...props} />
      </animated.div>
    );
  }

  function  ItemMenu(props){
    var lista=[]; 

            if(props.permisos_usuario!==undefined)
            {
            props.permisos_usuario.forEach( function getCheck(item2, index2) {
            if(item2.ID_PERMISO_PADRE===props.permiso)
            {
            lista.push(
                item2.MENU===1?
                <ItemMenu permisos_usuario={props.permisos_usuario} cargar={props.cargar} key={"IM-"+item2.ID_PERMISO.toString()} nombre={item2.NOMBRE} usuario={props.usuario} plataforma={props.plataforma}
                permiso={item2.ID_PERMISO} border={0}/>
                :
                <ListItem 
                onClick={props.cargar({reporte: item2.REPORTE,i:item2.IMPRESION,e:item2.ESCRITURA,l:item2.LECTURA,permiso: item2.ID_PERMISO,pagina: item2.INSTANCIA, nombre: item2.NOMBRE, descripcion:item2.DESCRIPCION, icono: item2.NOM_ICONO, manual: item2.TIENE_MANUAL})
                        } dense //divider 
                key={'ltt-'+item2.ID_PERMISO.toString()} button style={{borderRadius: "0px 100px 100px 0px",width: "100%" 
                , padding: "0 0 0 0", marginLeft:10}}>
                   <Iconos icono={item2.NOM_ICONO} style={{marginRight: 10 ,}} fontSize='small' color='disabled'/>
                   <ListItemText key={'lIt-'+item2.ID_PERMISO.toString()} primary={item2.NOMBRE} />
                </ListItem>  
            );
            }
          });
        }
       // });
        return (  
          <TreeItem  key={'treed-'+props.permiso.toString()} nodeId={props.permiso.toString()} 
            label={props.nombre} style={{padding:0,paddingLeft:5,marginBottom:5, color: "inherit", borderLeft: props.border===1?'1px solid #D8D8D8':'0'}} >
             {lista}
          </TreeItem>
        );
}

/*                                        EXPORT                                      */
export default withStyles(styles)(
  class Menu extends React.Component {

    constructor(props) {

      super(props);
      this.nombre = props.nombre;
      this.carrera = props.carrera;
      this.descrip_sucursal=props.descrip_sucursal;
      this.id_control_matricula = props.id_control_matricula;
      this.cargar = props.cargar
      this.logout =props.logout
      this.Limpiar_Principal=props.Limpiar_Principal
      this.changeswitch_publicaciones=props.changeswitch_publicaciones
      this.isVisibleRowSelected=isVisibleRowSelected
      this.año = props.año
      this.lista_para_filtrar=[]

       this.state = {
          switch: localStorage.getItem('switch')==='false'?false:true,
          open: false,
          lista_menu: [], lista: [], Lista_general_menu: [],
          top: false, left: false ,bottom: false ,right: false,
          foto: null,
          busqueda:'',
          expandir_menu: false,
          permisos_usuario: props.permisos_usuario,
          open_redis:   false,
          rows_redis: [],
          selection:  [],
          filters:    [],
          openBackdrop: false,
          total_usuarios: 0,
          total_solicitudes: 0,
          total_bloqueados: 0,
       }

       const TableRow = TableRow => withStyles(styles, { name: "Row" })( ({classes,highlighted, rowIndex, row, selectByRowClick, ...props}) => {

        const odd = !!(rowIndex % 2);
        const r = props.tableRow 
        
        const clickselection = (USER,VALUE) => event =>{
            this.setState({ selection: [{USER:USER,VALUE:VALUE}] });
            event.preventDefault();
        }
                
        if (this.state.selection[0]===undefined?this.state.selection[0]:this.state.selection[0].USER === props.tableRow.row.USER) { isVisibleRowSelected = true; }
           return (
               <Table.Row {...props}
                 onClick={clickselection(r.row.USER,r.row.VALUE)}
               style={{
                   cursor: 'pointer',
                   backgroundColor:  this.state.selection[0]===undefined?odd ? alternateColorRow1 : alternateColorRow2:this.state.selection[0].USER === props.tableRow.row.USER ? colorRowSelected : 
                   odd ? alternateColorRow1 : alternateColorRow2,                 
                   padding: '0rem 0rem !important',
                   margin: '0px',                 
                 }}
   
               />
             );
       });

       const VirtualTable_cellComponent = (props) => {
        const { column }    = props;
        const {row}         = props;
  
        if(column.name==='BLOCKED'){
          return(
            <Table.Cell {...props} style={{color: row.BLOCKED?'red':'black'}}>
              {row.BLOCKED?
              'Bloqueado'
              :' '
              }
            </Table.Cell>
          );
        }
  
        return(
            <Table.Cell {...props} />
          );
      }

       this.VirtualTable_cellComponent = VirtualTable_cellComponent
       this.TableRow = TableRow(Table.Row);
}; //FIN CONSTRUCTORS

llenado=()=>{
      var _this=this
      Request.get(`${ip}/obtenerfoto_carnet/${Auth.getProfile().user}`)
      .retry(10)
      .timeout({ response: 40000, deadline: 60000, })
      .end((err, res2)=>{
        if (err) { 
          if (err.toString().substr(0,16) === 'Error: Forbidden')
          {
            window.location.reload();
            return;
          }
          return;
        }
        try{
            const tmp2 = JSON.parse(res2.text);
            tmp2.forEach(function getCheck(item2, index2){
              _this.setState({foto: 'data: image/jpg;base64,'+item2.FOTO.replace('<FOTO>','').replace('</FOTO>','')});
            })
          }
          catch(ex){}
      })

        Request.get(`${ip}/obtenermenugeneral/${Auth.getProfile().plataforma}`)
        .set({'authorization': 'Bearer ' + Auth.getToken() })
        .retry(2)
        .timeout({ response: 30000, deadline: 60000, }) 
        .end((err, res)=>{
          if (err) { 
            if (err.toString().substr(0,16) === 'Error: Forbidden')
            {  
              window.location.reload();
              return;    
            }
            return;
          }
          try{
              const tmp = JSON.parse(res.text);
              if(tmp.length>0){
                var found
                var general=[]
              tmp.forEach(function getCheck(item, index){
                found = general.find(grupo => grupo.ID_MENU_GENERAL === item.ID_MENU_GENERAL);
                      if(found == null){
                        general.push(item)
                      Lista_general_menu.push(
                        <div key={'divmenu-'+item.ID_MENU_GENERAL.toString()}>
                          <Typography key={'Typography-'+item.ID_MENU_GENERAL.toString()}  style={{marginLeft: 10, padding: 0,}} color='textSecondary'>
                            {item.DESCRIPCION_HDR}
                          </Typography>
                          <List key={'MList-'+item.ID_MENU_GENERAL.toString()}>
                              {tmp.map((i,index) =>{
                                if(i.ID_MENU_GENERAL===item.ID_MENU_GENERAL)
                                return(
                                  <ListItem dense button key={'lmenu'+i.ID_MENU_GENERAL.toString()+i.NOMBRE_DTL} 
                                  style={{ width:'98%', borderRadius: "100px 100px 100px 100px"
                                  ,background:'rgba(255,146,10,0.01)'}} onClick={i.INSTANCIA==='logout'?_this.Cerrar_sesion:_this.cargar({reporte: i.REPORTE,i:i.IMPRESION,e:i.ESCRITURA,l:i.LECTURA,permiso: i.ID_PERMISO,pagina: i.INSTANCIA, nombre: i.NOMBRE, descripcion:i.DESCRIPCION, icono: i.NOM_ICONO, manual: i.TIENE_MANUAL})}>
                                  {i.NOM_ICONO!=null?
                                    <ListItemIcon key={'lmenulii-'+i.ID_MENU_GENERAL.toString()+i.NOMBRE_DTL}>
                                      <Iconos key={'lmenui-'+i.ID_MENU_GENERAL.toString()+i.NOMBRE_DTL} icono={i.NOM_ICONO}  />
                                    </ListItemIcon>:null}
                                    <ListItemText key={'lmenulit-'+i.ID_MENU_GENERAL.toString()+i.NOMBRE_DTL}  primary={i.NOMBRE_DTL} />
                                </ListItem>
                                );
                                return null;
                              })}
                          </List>
                        </div>
                      );
                      }
                      else
                      found = null;
                    })
                  }
              }
              catch(ex){}
            })
            ////////////////////////////////////////////////////////////////////////////
            var found
            var found2
            var menu=[]
            var menu_modulos=[]
            this.state.permisos_usuario.forEach( function getCheck(item, index2) {
              found2 = menu_modulos.find(grupo => grupo.ID_MODULO === item.ID_MODULO);
              if(found2 == null)
                menu_modulos.push(item)
              else
                found2=null
            })
            this.state.permisos_usuario.forEach( function getCheck(item, index2) {
              found = menu.find(grupo => grupo.ID_MODULO === item.ID_MODULO);
                if(found == null){
                  menu.push(item)
                  lista_encabezado.push(
                      <TreeItem style={{marginLeft: !item.CONTIENE_PERMISOS?10:0,width: '100%',marginBottom:menu_modulos.length>4?0:10,padding:0}}  
                        key={'a-'+item.ID_MODULO.toString()}  
                        nodeId={item.ID_MODULO.toString()} 
                        TransitionComponent={TransitionComponent}
                        label={<div style={{marginTop:10,marginBottom:10,display: 'flex',alignItems: 'center',verticalAlign:'middle', color: item.CONTIENE_PERMISOS?'#5D5147':'grey'}}>
                            <Iconos key={"I-"+item.DESCRIPCION_MODULO+'-'+item.ID_MODULO.toString()} icono={item.NOM_ICONO_MODULO}  
                            style={{color: item.CONTIENE_PERMISOS?colores.menu.color_icono_modulo:'grey'}}/>
                            <Typography variant="body2" style={{marginLeft: 20,fontWeight: '600'}}>{item.DESCRIPCION_MODULO}</Typography>
                            </div>
                           }
                      >
                        {item.CONTIENE_PERMISOS?
                          _this.state.permisos_usuario.map((item2,index2)=> {
                          if(item2.ID_MODULO===item.ID_MODULO)
                          {
                            if(item2.MENU===0 )
                              lista_filtro.push(
                                <ListItem onClick={_this.cargar({reporte: item2.REPORTE,i:item2.IMPRESION,e:item2.ESCRITURA,l:item2.LECTURA,permiso: item2.ID_PERMISO,pagina: item2.INSTANCIA, nombre: item2.NOMBRE, descripcion:item2.DESCRIPCION, icono: item2.NOM_ICONO, manual: item2.TIENE_MANUAL})} 
                                  key={'F-'+item2.NOMBRE+"-"+item2.ID_PERMISO.toString()} dense divider button
                                  style={{ borderRadius: "0px", width: "100%" , padding: "0 0 0 0", paddingLeft: 0}}>
                                <Iconos key={'FIconos'+item2.NOMBRE+"-"+item2.ID_PERMISO.toString()} icono={item2.NOM_ICONO} 
                                  style={{marginLeft:5,marginRight: 10}} color='disabled' /> 
                                <ListItemText key={'FListItemText'+item2.NOMBRE+"-"+item2.ID_PERMISO.toString()}  primary={item2.NOMBRE} style={{color: "inherit"}}/>
                                </ListItem>   
                              )
                              return(
                                item2.MENU===0&&item2.ID_PERMISO_PADRE===null?
                                  <ListItem 
                                    key={"ListItemb-"+item2.ID_PERMISO.toString()} dense  button 
                                    onClick={_this.cargar({reporte: item2.REPORTE,i:item2.IMPRESION,e:item2.ESCRITURA,l:item2.LECTURA
                                    ,permiso: item2.ID_PERMISO,pagina: item2.INSTANCIA, nombre: item2.NOMBRE, descripcion:item2.DESCRIPCION
                                    ,icono: item2.NOM_ICONO, manual: item2.TIENE_MANUAL})}
                                    style={{borderRadius: "0px 100px 100px 0px"
                                    ,width: "100%" ,padding: "0 0 0 0", paddingLeft: 5 }}
                                  >
                                    <Iconos key={'ListItembI-'+item2.ID_PERMISO.toString()} fontSize='small' icono={item2.NOM_ICONO} style={{marginRight: 10}} color='disabled' /> 
                                    <ListItemText  key={'ListItembT-'+item2.ID_PERMISO.toString()} primary={item2.NOMBRE} style={{color: "inherit"}}/>
                                  </ListItem>            
                                  :item2.ID_PERMISO_PADRE===null?
                                    <ItemMenu permisos_usuario={ _this.state.permisos_usuario} key={'IMG-'+item2.ID_PERMISO.toString()} usuario={Auth.getProfile().user} plataforma={Auth.getProfile().plataforma}  cargar={_this.cargar} nombre={item2.DESCRIPCION} permiso={item2.ID_PERMISO} border={0}/>
                                  :null
                            )}
                            return null;
                            })
                            :undefined}
                            </TreeItem>
                  )
                  }
                  else{
                    found=null
                  }
            })
        this.setState({lista: lista_encabezado,lista_menu: Lista_general_menu})    
}

handleChange = (event)=> {
    var frase='';
    if(event.target.value==='*'||'('||')'||'['||']'||'?'||"\\"||'+')
    {
      frase=event.target.value.replace(/[*()?+]/gi,'').replace('[','').replace(']','').replace("\\",'');
    }
    else
    {frase=event.target.value}

      if(event.target.value!==undefined)
      if(event.target.value.length>0)
        this.setState({busqueda: frase});
      else
        this.setState({busqueda: event.target.value});
}

handleChange_close= (event)=> {
    this.setState({busqueda: ''});    
}

toggleDrawer = (side, open) => event => {
      if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }
      this.setState({ [side]: open});
};

Clickexpandir=()=>{
   this.setState({expandir_menu: this.state.expandir_menu?false:true})
}

componentDidMount(){
  lista_encabezado=[];
  lista_filtro=[];
  Lista_general_menu=[];
  this.llenado();
 }

 Cerrar_sesion=()=>{
      this.logout()
      this.Limpiar_Principal()
 }

componentDidUpdate(){
    if(localStorage.getItem('estado_menu') !== this.state.left && localStorage.getItem('estado_menu')==='false')
    {
      localStorage.setItem('estado_menu',true)
      this.setState({left:false})
    }
}

changeswitch=()=>(event)=>{
  this.setState({switch: event.target.checked},()=>{
    this.changeswitch_publicaciones(event.target.checked)
  })
  localStorage.setItem('switch', event.target.checked)
}

//////////////// REDIS
abrirdialog_redis=()=>{
  let _this = this;
  this.setState({openBackdrop: true},()=>{
  try{
  Request.get(`${ip}/usuarios/rateLimiter/counts`)
            .set({'authorization': 'Bearer ' + Auth.getToken() })
            .retry(0)
            .timeout({ response: 40000, deadline: 60000, }) 
            .end((err, res)=> {
                if (err) { 
                    if (err.toString().substr(0,16) === 'Error: Forbidden')
                    {
                      window.location.reload();
                      return;
                    }
                    (async function() {
                        funciones.showToast('e','Error de conexión')
                    })();//FIN FUNCION ASYNC
                    _this.setState({openBackdrop:false})
                    return;
                }
                const tmp = JSON.parse(res.text);
                var suma_sol=0;
                var suma_blo=0;

                if(tmp.length>0){
                  tmp.forEach(element => {
                    suma_sol=suma_sol+ parseInt(element.VALUE)
                    if(element.BLOCKED)
                    suma_blo=suma_blo+1
                  });
                  _this.setState({ open_redis:true,rows_redis: tmp,openBackdrop:false,total_usuarios: tmp.length,total_solicitudes: suma_sol,total_bloqueados: suma_blo})
                }
                else{_this.setState({rows_redis: [],openBackdrop:false,total_usuarios: 0,total_solicitudes: suma_sol,total_bloqueados: suma_blo})}
              })
            }
            catch(ex){
              _this.setState({openBackdrop:false})
            }
})
}

cerrarredis=()=>event=>{
  this.setState({open_redis:false,selection:[]})
}

quitarbloqueo=()=>{

  if(this.state.selection[0]!==undefined)
  this.setState({openBackdrop: true},()=>{
  try{
    new Request.post(`${globales.ip}/usuarios/rateLimiter/counts`)
    .set({'authorization': 'Bearer ' + Auth.getToken() })
    .set('Content-Type', 'application/json')
    .send({USUARIO:   Auth.getProfile().user, key: this.state.selection[0].USER})
    .retry(0)
    .timeout({ response: 50000, deadline: 60000, }) 
    .end((err, res) => {
        if (err) { 
            if (err.toString().substr(0,16) === 'Error: Forbidden')
            { 
              window.location.reload();
              return;  
            }       
            funciones.showToast('e', 'Error de conexión'); 
            this.setState({openBackdrop:false})
            return;
        }
          this.setState({selection: [],filters: [],openBackdrop:false})
          this.abrirdialog_redis()
          funciones.showToast('s','Bloqueo Limpiado..')
    })
  }
  catch(ex){funciones.showToast('e','Error en el proceso'); this.setState({openBackdrop:false}) }
})
else{funciones.showToast('w','Seleccione un usuario.')}
}
changeFilters = filters => this.setState({ filters }); 

intentar_denuevo=()=>{window.location.reload();}

  /*                                          RENDER                          */
render() {
  const {classes}  = this.props;

  return (
    <div className={'Div-principal'}>
      <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Backdrop className='Backdrop-general' open={this.state.openBackdrop}><CircularProgress color="inherit" /></Backdrop>
      <Dialog fullWidth 
      fullScreen={movil_pequeño?true:false}
      maxWidth='md' open={this.state.open_redis} onEscapeKeyDown={this.cerrarredis()}
      style={{zIndex: 200000,}}
      >
        <DialogTitle><Typography component='span' variant='subtitle2'>Monitoreo Solicitud por Cliente</Typography></DialogTitle>
        <DialogContent style={{padding:0,margin:0,marginTop:1}}>
        <CustomTable
          Columns={columns}   Rows={this.state.rows_redis}                                   
          TableColumnExtensions={tableColumnExtensions}
          Filters = {this.state.filters}
          onFiltersChange = {this.changeFilters}
          //DefaultHiddenColumnNames={defaultHiddenColumnNames}
          VirtualTable_cellComponent={this.VirtualTable_cellComponent}
          getRowId = {getRowId}
          height={movil_pequeño?'450px':'300px'} enabledFilterRows= {true}
          RowComponent={this.TableRow} standarPlugin = { <TableRowsIndexer /> } showSelectionColumn={false}
        />
        <div align='center' style={{display: 'flex',width:'100%',justifyContent: 'center',marginBottom: 10,marginTop: 0}}>
          <Typography variant='subtitle1'><b>{'#Usuarios:  '}</b>{this.state.total_usuarios}</Typography>
          <Typography variant='subtitle1' style={{marginLeft:20}}><b>{'#Bloqueados:  '}</b>{this.state.total_bloqueados}</Typography>
          <Typography variant='subtitle1' style={{marginLeft:20}}><b>{'#Solicitudes:  '}</b>{this.state.total_solicitudes}</Typography>
        </div>
        </DialogContent>
        <DialogActions>
            {Auth.getProfile().rol===42?
            <Button className={classes.button}  onClick={this.quitarbloqueo}  size='small' startIcon={<ClearAllIcon/>} variant='text' style={{textTransform:'none',color:'green'}}>Desbloquear</Button>
            :null}           
            <Button className={classes.button} onClick={this.abrirdialog_redis}  size='small' startIcon={<CachedIcon/>} variant='text'  style={{textTransform:'none',color:'blue'}}>Actualizar</Button>
            <Button className={classes.button} onClick={this.cerrarredis()} size='small' startIcon={<CloseIcon/>} variant='text' style={{textTransform:'none',color:'red'}}>Cerrar</Button>
        </DialogActions>
      </Dialog>
      <AppBar  key="Appbar-principal" className={movil_pequeño?'Appbar-principal-movil':'Appbar-principal'} >
      <Toolbar  key="Toolbar" variant="dense" className={movil_pequeño?'Toolbar-principal-m':'Toolbar-principal'}>
            <IconButton className={'Appbar-botonmenu'} aria-label="opendrawer" onClick={this.toggleDrawer('left', true)} edge="start">
              <Iconos icono='MenuIcon' className={'Appbar-iconomenu'}/>
            </IconButton>
            <Avatar alt="Usuario" src={this.state.foto} className={'Appbar-avatar-usuario'} />
            <Typography className={movil_pequeño?'Appbar-typography-nombre-movil':'Appbar-typography-nombre-pc'} >{this.nombre}</Typography>
            {/*<Typography className={movil_pequeño?'Appbar-typography-sucursal-movil':'Appbar-typography-sucursal-pc'}>{this.descrip_sucursal}</Typography>
            */}
            {ACTIVAR_REDIS && Auth.getProfile().rol===42?
            <Tooltip id="Redis" title="Redis">
            <IconButton onClick={this.abrirdialog_redis} size='small' variant='outlined' style={{color: 'white',textTransform:'none', marginRight:10}}>
              <DvrIcon/>
            </IconButton>
            </Tooltip>
            :null
            }
         {/* <Avatar src={'/Multimedia/logo.png'} className={'Appbar-avatar-logo'}/>*/}
          <Tooltip id="imprimir" title="Salir" >
            <IconButton onClick={this.Cerrar_sesion} className={'Appbar-botonsalir'} >
              <Iconos icono={'ExitToAppRounded'} className={'Appbar-iconosalir'} />
            </IconButton>
          </Tooltip>
      </Toolbar>
      </AppBar>
      <Drawer key={'Drawer'} className={'Drawer'} variant="temporary" 
      anchor="left" open={this.state.left} 
        classes={{paper: movil_pequeño?'Drawer-paper-m':movil_ipad?'Drawer-paper-i':this.state.expandir_menu?'Drawer-paper-p2':window.innerWidth<700?'Drawer-paper-pe':'Drawer-paper-p',}} onClose={this.toggleDrawer('left', false)}
      >
      <div key={'Div-fondo'} className={movil_pequeño?'Div-fondo-m':movil_ipad?'Div-fondo-i':this.state.expandir_menu?'Div-fondo-p2':'Div-fondo-p'} >
        <List className={'List-contenedor'}>
        <ListItem  component='div' style={{padding:0}}>
        <GridListTileBar key={'Boton_cerrar'}
          titlePosition="top" className={movil_pequeño?'Boton_cerrar-m':"Boton_cerrar"}
          actionIcon={<IconButton onClick={this.toggleDrawer('left', false)} className={"Boton_cerrar_icono"}><Iconos icono='ChevronLeftIcon'/></IconButton>}
        />
        </ListItem>
        <div key={'Foto_ListItemAvatar'}   className={movil_pequeño?'Foto_ListItemAvatar-m':"Foto_ListItemAvatar"}>
          <Avatar key={'Foto_Avatar'}  alt="Usuario" src={this.state.foto}  className={movil_pequeño?"Foto_Avatar-m":movil_ipad?"Foto_Avatar-i":"Foto_Avatar-p"} />
          <Typography className={'Contenido_typography_nombre'}>{this.nombre}</Typography>
        </div>
        <ListItem key={'Contenido_info'} component='div' className={movil_pequeño?'Contenido_info-m':'Contenido_info'}>
        <GridListTileBar key={'Contenido_info_grid'} titlePosition="top" className={'Contenido_info_grid'}
                title={<div><div style={{display:'flex',alignItems:'center',marginBottom:5}}>
                    <MoodRoundedIcon style={{color: 'rgba(3,25,48,1)',marginRight:5,padding:0}}/>
                    <Typography  className={'Contenido_Typography_Bienvenido'}>{'Bienvenido'}</Typography> 
                    </div>
                    <Divider/>
                    </div>
                }
                subtitle={<div><Typography className={'Contenido_typography_cuenta'}>{Auth.getProfile().user}</Typography><Typography className={'Contenido_typography_carrera'}>{this.carrera}</Typography></div>}
        />
        </ListItem>
        </List>
      </div>
      <div key={'div-busqueda'} className={'Div-busqueda'} >
      <AppBar key={'Bar-busqueda'} className={'Appbar-busqueda'} >
        <Toolbar key={'Toolbar-busqueda'} className={'Tollbar-busqueda'} variant="dense">
          <div key={'div-Search'} className={'Div-search'} >
                <Iconos icono='Search' className={'Icono-busqueda'} />
                <InputBase key={'input-buscar'}
                  placeholder="Buscar . . . . ." onChange={this.handleChange} value={this.state.busqueda}
                  classes={{root: 'Inputroot-busqueda',input: 'Input-busqueda'}} inputProps={{ 'aria-label': 'search' }}
                />
          </div>
          <IconButton key={'Boton-backspace-busqueda'} onClick={this.handleChange_close} className={'Boton-backspace-busqueda'}  color='secondary' size='small'
            disabled={this.state.busqueda===undefined||this.state.busqueda===""?true:false}>
           <Iconos fontSize='small' icono='Backspace'/>
          </IconButton>
        </Toolbar>
      </AppBar>
      </div>
      <div key={'div-principal'} className={movil_pequeño?'Div-menu-m':'Div-menu-p'}>
        <Paper key={'Paper-principal'} className={'Paper-menu'}>
            {
              this.state.permisos_usuario.length===0?
              <div align='center' style={{marginTop:15}}>
                <Iconos icono="PermScanWifi" fontSize='large' style={{color:colores.naranja,marginBottom:15}} />
                <Typography align='center' variant='h6'><b>Ups... Algo salió mal</b></Typography>
                <Typography align='center' variant='subtitle1'>Verifique su conexión de internet e inténtelo de nuevo</Typography>
                <Button onClick={this.intentar_denuevo} variant='contained' style={{background:colores.naranja,color:'whitesmoke',textTransform:'none',marginTop:20}} >Intentar de nuevo</Button>
              </div>
              :null
            }
            {this.state.busqueda===undefined||this.state.busqueda===""? <TreeView key={'TreeView-principal'} defaultEndIcon={<Iconos icono={'ChevronRightIcon'} />} defaultCollapseIcon={<Iconos icono='ExpandMoreIcon'/>} defaultExpandIcon={<Iconos icono='ChevronRightIcon'/>}>{this.state.lista}</TreeView>:<div style={{marginTop: 10}}>{[lista_filtro.filter(busqueda2 => busqueda2.key.toLowerCase().match(this.state.busqueda.toLowerCase()))].map((text,index)=>(text))}</div>}
        </Paper>
      </div>
        <div style={{marginTop: 'auto'}}>
        <Divider style={{width:'90%',opacity:0.6}}/>
        <ListItem onClick={()=>{window.open(globales.menu.url_moodle,'blank')}} button
        style={{ width:'98%', borderRadius: "100px 100px 100px 100px",background:'rgba(255,146,10,0.01)'}}
        >
          <ListItemIcon style={{marginLeft:10,color: colores.azul}}><Iconos icono="HomeWork"/></ListItemIcon>
          <ListItemText style={{color: colores.azul}} primary='Campus Virtual (Moodle)' />
        </ListItem>
        <Divider style={{width:'90%',opacity:0.6}}/>
        {
        Auth.getProfile().plataforma===1?
        <React.Fragment>
          <FormControlLabel
                control={<Switch checked={this.state.switch} 
                classes={{
                  root: classes.root,
                  switchBase: classes.Switch,
                  thumb: classes.thumb,
                  track: classes.track,
                  checked: classes.checked,
                }} 
                onChange={this.changeswitch()}/>}
                label="Publicaciones"
                style={{marginLeft: 5}}
          />
          <Divider style={{width:'90%',marginBottom:5,opacity:0.6}}/>
        </React.Fragment>
        :null
        } 
        {this.state.lista_menu.map((text,index)=>(text) )}
        </div>
      </Drawer>
      </MuiThemeProvider>
    </div>
  );
} /// finaliza render
} /// finaliza class
)/// finaliza withStyles